import { render } from "./EditLanguage.vue?vue&type=template&id=35548a08"
import script from "./EditLanguage.vue?vue&type=script&lang=js"
export * from "./EditLanguage.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__